module.exports = __webpack_public_path__ + "img/29.cf1d6dab.png";